const OdooCustomerAddressView = ({ address, inline }) => {
  return (
    <div className="space-y-1">
      {address.function && <div>{address.function}</div>}
      <p className="mb-1">
        <b>{address.name}</b>
        {address.function && ` (${address.function})`}
      </p>
      {address.phone && <p>☎️ {address.phone}</p>}
      {address.email && <p>📧 {address.email}</p>}
      <p className="whitespace-pre-wrap">
        {inline ? address.contact_address_inline : address.contact_address}
      </p>
    </div>
  );
};

export default OdooCustomerAddressView;
